import { Fragment, memo, useCallback, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';

import { getColor, QueryDropdown, Radio, RadioGroup, Switch } from 'basic-components';
import { CommonEnums } from 'dashboard-services/api/common';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { FormulaUtils } from 'utils';

import MetadataLabel from '../OutputType/MetadataLabel';
import SectionTitle from '../SectionTitle';

import { When } from 'react-if';

const EMPTY_ARRAY = [];
const OVERRIDDEN_DEFAULT = { label: FormulaUtils.OVERRIDDEN, value: FormulaUtils.OVERRIDDEN }

const ColumnsOrder = ({ onChange, sortKeys = undefined, sortKeysBy = undefined, sortKeysOrder = undefined, keys = EMPTY_ARRAY, isPendingKeys, sortKeysOverridden = false, sortKeysByOverridden = false, sortKeysOrderOverridden = false }) => {
  const callsRefs = useRef([]),
        onChangeSortBy = useCallback((_, { name, data }) => onChange(data ? { key: data.value, type: data.type } : undefined, { name }), [onChange]),
        onChangeBool = useCallback((val, { name }) => onChange(String(val), { name }), [onChange]),
        defaultSortKeysBy = useMemo(() => sortKeysBy ? ({
          value: sortKeysBy.key,
          label: sortKeysBy.type === DataStorageEnums.CSV_HEADER_TYPE.METADATA_KEY ? (<MetadataLabel name={sortKeysBy.key}/>) : sortKeysBy.key,
          color: sortKeysBy.type === DataStorageEnums.CSV_HEADER_TYPE.METADATA_KEY ? getColor("grey-dark") : undefined,
          type: sortKeysBy.type
        }) : undefined, [sortKeysBy])

  useEffect(() => () => {
    callsRefs.current.forEach(promiseObj => promiseObj?.cancel())
  }, [])

  return (
    <Fragment>
      <SectionTitle>
        DATA SORTING
      </SectionTitle>
      <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__switch ng-office-app__authed__content__body__item__expanded-settings__bottom__switch--is-small-margin">
        <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label">
          Sort keys
        </div>
        <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value">
          <Switch
              disabled={sortKeysOverridden}
              name="sortKeys"
              noError
              on={sortKeys === "true"}
              onChange={onChangeBool}
          />
        </div>
      </div>
      <When condition={sortKeys === "true"}>
        {() => (
          <Fragment>
            <div
                className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label"
                id="sort-keys-by"
            >
              Sort keys by
            </div>
            <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value">
                <QueryDropdown
                    defaultValue={sortKeysByOverridden ? [OVERRIDDEN_DEFAULT] : defaultSortKeysBy}
                    disabled={sortKeysByOverridden}
                    fixed
                    isFetching={isPendingKeys}
                    labelId="sort-keys-by"
                    menuPortalTarget={document.querySelector('.ng-office-app')}
                    name="sortKeysBy"
                    noError
                    onChange={onChangeSortBy}
                    openMenuOnFocus
                    options={keys}
                    variant="border"
              />
            </div>
            <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label">
              Sort keys order
            </div>
            <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value ng-office-app__authed__content__body__item__expanded-settings__bottom__value--radio">
                <RadioGroup
                    disabled={sortKeysOrderOverridden}
                    name="sortKeysOrder"
                    onChange={onChange}
                    selectedValue={Object.values(CommonEnums.SORT_ORDER).includes(sortKeysOrder) ? sortKeysOrder : CommonEnums.SORT_ORDER.ASCENDING}
                >
                <Radio name={CommonEnums.SORT_ORDER.ASCENDING}>
                  Ascending
                </Radio>
                <Radio name={CommonEnums.SORT_ORDER.DESCENDING}>
                  Descending
                </Radio>
              </RadioGroup>
            </div>
          </Fragment>
        )}
      </When>
    </Fragment>
  )
}

ColumnsOrder.propTypes = {
  isPendingKeys: PropTypes.bool.isRequired,
  keys: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  sortKeys: PropTypes.string,
  sortKeysBy: PropTypes.object,
  sortKeysByOverridden: PropTypes.bool,
  sortKeysOrder: PropTypes.string,
  sortKeysOrderOverridden: PropTypes.bool,
  sortKeysOverridden: PropTypes.bool
}

export default memo(ColumnsOrder)
